import { gql } from '@apollo/client';
import type { Billet, QueryBilletsArgs } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLBilletsRequester {
  public getBillets = (companyId: string, status?: string): Promise<Billet[]> => {
    return graphQLRequester
      .query<{ billets: Billet[] }, QueryBilletsArgs>({
        query: gql`
          query billets($companyId: ID!, $status: String) {
            billets(companyId: $companyId, status: $status) {
              id
              idDoc
              idCompany
              boletoLink
              subject
              fileName
              dataEmissao
              status
              dataVencimento
              barCode
              digitableLine
              titleValue
              nrDocumento
              nrNfse
              validFrom
              validTo
              runnedAt
              seqCode
              nrDocEntry
              nrNoteEntry
              cardCode
              cardName
              datePayment
              idContract
              payedValue
              diaProRata
              source
              nfeLink
              nfeDataEmissao
              nfeHoraEmissao
              nfeTitleValue
              nfeIdContract
            }
          }
        `,
        variables: { companyId, status },
      })
      .then((response) => response.billets?.filter((item): item is Billet => !!item) ?? []);
  };
}

export default GraphQLBilletsRequester;
